<template>
  <div class="page-content"  id="retrievalTask">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/dataRetrieval' }">数据检索</el-breadcrumb-item>
      <el-breadcrumb-item>创建检索任务</el-breadcrumb-item>
    </el-breadcrumb>
    <section class="seaerch-wrapper">
      <el-form label-width="130px">
        <el-form-item label="平台：" :required="true">
          <el-select
            size="small"
            v-model="newPlatForm"
            placeholder="请选择"
            style="width: 425px;"
          >
            <el-option
              v-for="item in platFormArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="获取信息：" :required="true">
          <el-radio v-model="infotype" label="1">
            列表页
            <el-tooltip class="item" effect="dark" content="只获取列表页页面价格，不获取详情优惠券及SKU信息" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </el-radio>
          <el-radio v-model="infotype" label="2">
            列表页+详情页
            <el-tooltip class="item" effect="dark" content="获取详情页价格、优惠券及SKU信息，到手价将按照品牌检索标准设置的进行计算" placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </el-radio>
        </el-form-item>

        <el-form-item label="更新方式：" :required="true">
          <el-radio v-model="changetime" label="0">
            即刻检索
          </el-radio>
          <el-radio v-model="changetime" label="1">
            定时检索
          </el-radio>
          <div v-if="changetime == 1">
            <el-date-picker
              size="mini"
              v-model="dayData"
              type="date"
              placeholder="选择日期"
              style="width: 280px;"
              :picker-options="pickerOptions"
              @change="changeDate">
            </el-date-picker>
            -
            <el-time-select
              size="mini"
              v-model="timeData"
              :picker-options="{
                start: timeStart,
                step: '01:00',
                end: '23:00'
              }"
              value-format="timestamp"
              placeholder="选择时间"
              style="width: 134px;">
            </el-time-select>
          </div>
        </el-form-item>

        <el-form-item label="页数范围：" :required="true">
          <el-select
            size="small"
            v-model="page"
            placeholder="请选择"
            style="width: 425px;"
          >
            <el-option
              v-for="item in pageData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="检索关键词：" :required="true">
          <div class="addFont" @click="newAdd">
            <i class="el-icon-plus"></i>
            添加检索关键词
          </div>
        </el-form-item>
      </el-form>

      <el-button size="small" style="margin-left: 47px;margin-bottom: 8px;" @click="delSure('批量删除')">
        批量删除
      </el-button>
      <el-table
        @selection-change="handleSelectionChange"
        :data="productsData"
        ref="multipleTable"
        style="padding-left: 47px;padding-bottom: 10px;"
        height="460"
        >
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="检索关键词" prop="platformchild">
          <template slot-scope="scope">
            {{scope.row.shopnamechild}}
					</template>
        </el-table-column>
        <el-table-column width="210" label="操作">
          <template slot-scope="scope">
            <div class="g-margin-left" style="color: #108cee;cursor: pointer;">
              <i class="el-icon-delete"></i>
              <span class="g-inline-block" @click="delSure(scope.$index)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <antistopLink ref="childShopLink" @fromChild="getChild"></antistopLink>
      <div style="margin-left: 51px;margin-top: 40px;">
        <el-button size="small" class="g-confirm-btn" @click="save" type="primary" :loading="saveLoading">确 认</el-button>
  			<el-button size="small" class="g-cancel-btn" @click="$router.push(`/newStore`)" type="TheCustom">取 消</el-button>
      </div>
    </section>
  </div>

</div>

</template>

<script>
  import antistopLink from "./antistopLink.vue";
  import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        timeStart: '00:00',
        pickerOptions: {
         disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        },
        newPlatForm: '',
        page: '',
        platFormArr: [
        //   {
        //   label: '淘宝天猫',
        //   value: 'TBTM'
        // },{
        //   label: '拼多多',
        //   value: 'PDD'
        // },
        {
          label: '京东',
          value: 'JD'
        },{
          label: '苏宁',
          value: 'SN'
        },{
          label: '1688',
          value: '1688'
        },{
          label: '当当',
          value: 'DD'
        }],
        pageData: [{
          label: '前1页',
          value: '1'
        },{
          label: '前5页',
          value: '5'
        },{
          label: '前10页',
          value: '10'
        },{
          label: '前20页',
          value: '20'
        },{
          label: '前60页',
          value: '60'
        },{
          label: '前100页',
          value: '100'
        }],
        infotype: '1',
        changetime: '0',
        timeData: '',
        dayData: '',
        saveLoading: false,
        multipleSelection:[],
        productsData: [],
      }
    },
    mounted() {
      // 未选中日期时时间处理
      this.defaultData()
    },
    methods: {
      // 选中日期时间处理
      changeDate() {
        if (this.$options.filters['fullTime'] (this.dayData).substring(0,10) > this.$options.filters['fullTime'] (Date.now()).substring(0,10)) {
          this.timeStart = '00:00'
        } else {
          this.defaultData()
        }
      },
      // 时间初始处理
      defaultData() {
        let num = Number(this.$options.filters['fullTime'] (Date.now()).substring(11,13))
        let endNum = num + 1
        if (endNum > 9) {
          this.timeStart = endNum + ':00'
        } else {
          this.timeStart = '0' + endNum + ':00'
        }
      },
      // 新增监控产品
      newAdd() {
        let data = {
          productsData: this.productsData,
        }
        this.$refs.childShopLink.faOpen(data)
      },
      // 子传父
      getChild(data) {
        // 新增监控产品表格数据
        console.log('新增关键词表格数据')
        this.productsData = data
      },
      delSure(index) {
        if (index == '批量删除') {
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择关键词',
              type: "error"
            });
            return;
          }
          for (let a in this.multipleSelection) {
            for (let b in this.productsData) {
              if (this.multipleSelection[a] === this.productsData[b]) {
                this.productsData.splice(b,1)
              }
            }
          }
        } else {
          this.productsData.splice(index,1)
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      save() {
        console.log(this.newPlatForm)
        console.log(this.infotype)
        console.log(this.page)
        console.log(this.dayData)
        console.log(this.timeData)
        if (!this.newPlatForm) {
          this.$message({
            message: '请选择平台',
            type: 'warning'
          });
          return
        }
        if (this.changetime == '1') {
          if (!this.dayData) {
            this.$message({
              message: '请选择日期',
              type: 'warning'
            });
            return
          }
          if (!this.timeData) {
            this.$message({
              message: '请选择时间',
              type: 'warning'
            });
            return
          }
        }
        if (!this.page) {
          this.$message({
            message: '请选择页数范围',
            type: 'warning'
          });
          return
        }

        if (this.productsData.length == 0) {
          this.$message({
            message: '请添加关键词',
            type: 'warning'
          });
          return
        }
        // this.saveLoading = true
        let allData = []
        console.log(this.productsData)
        for (let b in this.productsData) {
          allData.push({
            keywordname: this.productsData[b].shopnamechild,
          })
        }
        console.log(allData)
        let params = {
          platform: this.newPlatForm,
          infotype: this.infotype,
          page: this.page,
        }
        params.childList = allData
        if (this.changetime == '1') {
          console.log(this.$options.filters['fullTime'] (this.dayData).substring(0,10))
          params.changetime = this.$options.filters['fullTime'] (this.dayData).substring(0,10) + ' ' + this.timeData + ':00'
        } else {
          params.changetime = this.changetime
        }
        fetch({
          method: 'POST',
  				url: 'hcm/hcmKeywords/save',
  				data: JSON.stringify(params),
  				headers: {
  					'Content-Type': 'application/json'
  				}
        }).then(res => {
          if(res.status == '10000'){
            this.saveLoading = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            // 新增的话数据清空
            this.newPlatForm = ''
            this.infotype = ''
            this.page = ''
            this.dayData = ''
            this.timeData = ''
            this.productsData = []
            this.$router.push(`/dataRetrieval`)
          } else {
            this.$message.error(res.message);
          }
        })
      },
    },
    components: {
      antistopLink
    }
  }
</script>
<style lang="scss">
  #retrievalTask{
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .addFont {
      color: #108cee;
      font-weight: bold;
      text-align: center;
      border: 1px dashed #e8ebec;
      height: 30px;
      width: 425px;
      line-height: 30px;
      cursor: pointer;
    }
    .addFont:hover {
      border: 1px dashed #108cee;
    }
  }
</style>
